import type { FaireProductEntity } from "../../entity_types/product";

export const p_y4vmcgdf97: FaireProductEntity = {
  token: "p_y4vmcgdf97",
  type: "product",
  name: "Jenna Hoops - Mosaic // Summer Spring Jewelry Earrings",
  brandToken: "b_bgu7e2icoo",
  brandName: "Spiffy & Splendid",
  imageUrl: "https://cdn.faire.com/fastly/5a785848b2320901a80d27010099a99aa10552921d6a9d415cc86558cc36c9d3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d780fe7a015e76481021cd09897f7395be3c33e4c7193b13137f6c3e83357374.jpeg",
    "https://cdn.faire.com/fastly/0f822fbd1dc1ed96075b38c249e489efdbfd72734fef9162be44cc0dc07133e2.jpeg",
    "https://cdn.faire.com/fastly/4aa0bb854d0dfa170033b9572293b5227518fdbb0d36f58ed2da30a57e94e7e9.jpeg",
    "https://cdn.faire.com/fastly/376e5970976bc9cd293db8a70555a67ba07955bb65d632ac237b2ef77ecd05a7.jpeg",
    "https://cdn.faire.com/fastly/784a38528222337f00dfdb838c273cc8eec7f2c30726802a685b760d24de7ad9.jpeg",
    "https://cdn.faire.com/fastly/8e674f7737b0c253fa356e9077bdaa2b5f4c1233a819fa2e1241f0807f4da701.jpeg",
    "https://cdn.faire.com/fastly/4f61d502458bcce7a6e526d313b5ee35e61c6c1e915f2b1d4532d7adeabdc3b8.jpeg",
    "https://cdn.faire.com/fastly/625160038f60c76cc57e2f9a28f920b99afba820455a276a350e59b6a779fb00.jpeg",
    "https://cdn.faire.com/fastly/d3ed3ac70eeb153a3f5c2714f1b9741749050739439b2f6e91ccc40723e045f3.jpeg"
  ],
  priceDollars: 7.5,
  description: "The Jenna Hoops\n\nRefresh your daily rotation with the Jenna Hoops, a modern take on the classic circular hoop. Featuring a gracefully curved silhouette, these hoops offer a smooth, sculptural aesthetic that catches the light beautifully. Their refined shape provides a soft yet bold look, making them an essential staple for anyone who loves a clean, contemporary finish to their outfit.\n\n✨ Details:\n\n * \nHypoallergenic stainless steel posts\n\n * \nLightweight and durable construction\n\n * \nApproximately 1.6\" length\n\n\n * \nColor patterns vary, making each pair unique\n\nStyle Tip: Let the Jenna Hoops be your go-to for effortless styling. Pair them with a breezy eyelet top and your favorite denim for a classic daytime look, or wear them with a sleek slip dress for a dinner out. Their curved profile adds a touch of sophisticated flair that complements everything from a messy beach bun to a polished ponytail.\n\nMSRP $19\n",
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:37:44.560Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
